import { issuePriority, issueStatusToText } from '@/ui/dictionary';
import { IssueStatus } from '@/entities/todo';
import { IssuePriority } from '@/entities/issue';
import { du, fromUnixTimestamp, t } from '@/ui/i18n/i18n';

export function useIssueActivities() {
  const valuesTranslation = {
    status: (value: IssueStatus) => issueStatusToText(value),
    priority: (value: IssuePriority) => issuePriority(value),
    due_at: (value: number) => du(new Date(fromUnixTimestamp(value)), 'shortDateTime'),
  };

  const fieldsTranslation = {
    title: t('common.title').toLowerCase(),
    description: t('common.description').toLowerCase(),
    photos: t('common.photos').toLowerCase(),
    status: t('common.status').toLowerCase(),
    entity_item_id: t('common.entity-item').toLowerCase(),
    assignees: t('common.assignees').toLowerCase(),
    priority: t('common.priority').toLowerCase(),
    due_at: t('common.deadline').toLowerCase(),
    reported_at: t('activity-log.reported_at').toLowerCase(),
    users: t('activity-log.assignees').toLowerCase(),
  };

  return {
    valuesTranslation,
    fieldsTranslation,
  };
}
